import { get, uniqBy } from 'lodash'
import { createSelector } from 'reselect'

import { auth } from 'providers/firebaseAuth'

// Firebase auth is shared across tabs, so another tab's login can leave this businessId behind. A
// selection stamped with a different uid is refused; ones persisted before uid existed carry none.
export const getSelectedBusinessId = state => {
  const { businessId = '', uid = '' } = get(state, 'LoginPersist.selectedLoginDetails', {})
  return !uid || uid === auth?.currentUser?.uid ? businessId : ''
}

// get First business details
export const getFirstAccountDetails = createSelector([state => state?.allBusinesses], (allBusinesses = []) => {
  const business = get(allBusinesses, '[0]', {})
  return {
    businessTitle: get(business, 'businessTitle'),
    businessName: get(business, 'businessName'),
    businessId: get(business, 'businessId'),
  }
})

// get all businesses
export const getAllBusinesses = (businesses = []) => {
  return uniqBy(
    businesses.map(row => ({ businessName: row.businessName, businessId: row.id, businessTitle: row.businessTitle })),
    'businessId'
  )
}
